import {useState} from 'react';

const useForm = (initialValue = {}) => {
    const [formData, setFormData] = useState(initialValue);

    const handleChange = (event) => {
        const { name, value } = event.target ?? {};
        setFormData((prevState) => ({ ...prevState, [name]: value }));
    }

    const resetForm = () => {
        setFormData(initialValue);
    }

    return {
        data: formData,
        handleChange,
        resetForm
    }
}

export default useForm;